Ext.define('SA.lq.edit.EditView', {
    alias: 'widget.lq-edit-view',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-view',

    initComponent() {
        this.items = [
            this.headerCmp,
            {
                xtype: 'simple-container',
                itemId: 'sectionsWrap',
                cls: 'sa-edit-view-sections-wrap',

                items: [
                    {
                        xtype: 'simple-container',
                        cls: 'sa-edit-view-sections',

                        items: [
                            {
                                xtype: 'simple-container',
                                cls: 'sa-edit-panel',

                                items: [
                                    {
                                        xtype: 'simple-container',
                                        cls: 'sa-edit-panel-header',

                                        items: [
                                            {
                                                xtype: 'component',
                                                cls: 'sa-edit-panel-header-title',
                                                html: 'Locations'
                                            }
                                        ]
                                    }, {
                                        xtype: 'simple-container',
                                        itemId: 'radiosContainer',
                                        cls: 'sa-edit-panel-enabled-section'
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];

        this.callParent();
    }
});